import React from 'react';
import {
  Table,
  TableCell,
  TableContainer,
  TableBody,
  CircularProgress,
  Box,
} from '@mui/material';

import {
  StyledTableRow,
  StyledTableCell,
  StyledWithdrawTableHead,
} from '../../Components/MaterialTableStyle/StyleTableCell';
import DATAIMG from '../../Assets/images/AirdropImg/DataImg.png';

type BridgeTableProps = {
  isLoading: boolean;
  columns: { id: number; columnName: string }[];
  children: React.ReactNode;
  isEmpty: boolean;
};

export const BridgeTable = ({
  isLoading,
  children,
  columns,
  isEmpty,
}: BridgeTableProps) => {
  return (
    <TableContainer
      className="customeScroll"
      sx={{
        background: 'transparent !important',
        maxHeight: { lg: '35vh', sm: '60vh' },
        overflowY: 'auto',
      }}
    >
      <Table stickyHeader aria-label="sticky table" sx={{ padding: '16px' }}>
        <StyledWithdrawTableHead>
          <StyledTableRow sx={{ padding: '16px !important' }}>
            {columns.map((column) => {
              return (
                <TableCell
                  key={column.id}
                  sx={{
                    color: '#ffffff',
                    fontSize: { xs: '10px', md: '13px' },
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    lineHeight: { xs: '12px', md: '19.5px' },
                  }}
                >
                  {column.columnName}
                </TableCell>
              );
            })}
          </StyledTableRow>
        </StyledWithdrawTableHead>
        {!isLoading ? (
          !isEmpty ? (
            children
          ) : (
            <TableBody>
              <StyledTableRow>
                <StyledTableCell colSpan={9} align="center">
                  <div className="flex justify-center w-full items-center gap-4">
                    <img
                      src={DATAIMG}
                      width={'120px'}
                      height={'120px'}
                      alt="logo"
                    />
                    <p className="text-center text-light mt-3">
                      No Transaction Available
                    </p>
                  </div>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          )
        ) : (
          <Box
            sx={{
              maxHeight: { lg: '35vh', sm: '60vh' },
              overflowY: 'auto',
            }}
          >
            <TableBody>
              <StyledTableRow>
                <StyledTableCell colSpan={7} align="center">
                  <span className="regular">
                    <CircularProgress style={{ color: '#FFFF' }} />
                  </span>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Box>
        )}
      </Table>
    </TableContainer>
  );
};
